require('./bootstrap');

import Vue from 'vue'
// import store from './store'
// import { mapState } from 'vuex'


window.eventHub = new Vue();
const queryString = require("query-string");

import AddCart from "./components/AddCart.vue";
import Qty from "./components/Qty.vue";
import SelectSpec from "./components/SelectSpec.vue";

import Swiper from 'swiper'


window.app = new Vue({
    el: '#app',
    data() {
        return {
            payment: 0,
            shipping: 0,
            vat: 0,
            applyCredit: 0,
            creditId: '',
            useCredit: 0,
            useBonus: 0,
            // ticketNo: "",
            carts: {
                ticketNo: "",
                items: [],
                total: 0,
                orgTotal: 0,
                shipping: 0,
                counts: 0,
                serviceFee: 0,
                shipFee: 0,
                shipFree: 0
            },
            selectSpec: null,
            specQty: 0,
            pdPrice: 0,
            pdOffer: 0,
            vat_type: 0,
        };
    },
    components: { AddCart, Qty, SelectSpec },
    mounted() {
        this.getCart();
        eventHub.$on("addCart", this.addCart);
        eventHub.$on("directAddCart", this.directAddCart);
        eventHub.$on("updateCart", this.getCart);
        eventHub.$on("updateSpec", this.changeSpec);

    },

    computed: {
        allowUseBonus() {
            return ((this.carts.total - this.carts.shipping) >= 50);
        }
    },
    methods: {
        addCart({ id, qty }) {
            let api = `/carts/add/${id}`;
            // console.log(api);
            let vm = this;
            axios.post(api, { qty: qty, selectSpec: vm.selectSpec }).then(r => {
                vm.getCart();
                alert(r.data.message);
            });
        },

        directAddCart({id, qty}) {
            let api = `/carts/add/${id}`;
            let vm = this;
            axios.post(api, { qty: qty, selectSpec: vm.selectSpec }).then(r => {
                vm.getCart();
                if(r.data.status === 1 ) {
                    alert(r.data.message);
                }
                window.location = '/cart/step1';
            });
        },

        addOne(id) {
            let api = `/carts/add/${id}`;
            console.log(api);
            let vm = this;
            axios.post(api, { qty: 1 }).then(r => {
                vm.getCart();
                alert(r.data.message, 'success');
            });
        },
        getCart() {
            let params = {
                shipping: this.shipping,
                payment: this.payment,
                useBonus: this.useBonus
                // applyCredit: this.applyCredit
            };

            if(this.creditId != '') {
                params.creditId = this.creditId;
            }

            let url = "/carts.json?" + queryString.stringify(params);

            axios.get(url).then(r => {
                this.carts = r.data;
            });
        },

        deleteCart(id) {
            let api = `/carts/${id}/delete`;
            let vm = this;
            axios.delete(api).then(r => {
                // vm.getCart();
                eventHub.$emit("updateCart");
                window.location.reload();
            });
        },
        setShip(ship) {
            let api = `/carts/setShip/${ship}`;
            let vm = this;

            axios.get(api).then(r => {
                vm.getCart();
            });
            // this.getCart();
        },

        setPayment(pay) {
            this.payment = pay;
            this.getCart();
        },

        applyTicket() {
            let vm = this;
            let params = {
                sn: this.carts.ticketNo
            };

            axios.post('/carts/applyTicket', params).then( r => {
                alert(r.data.message);
                vm.getCart();
            });
        },

        cancelTicket() {
            let vm = this;
            this.carts.ticketNo = '';
            axios.get('/carts/cancelTicket').then( r => {
                vm.getCart();
            })
        },

        getSpec(id) {
            let vm = this;
            axios.get(`/api/specs/${this.selectSpec}`).then(r => {
                vm.selectSpec = r.data.id;
                vm.specQty = r.data.qty;
                vm.pdPrice = r.data.price;
                vm.pdOffer = r.data.offer;
            })
        },

        changeSpec({row, specId}) {
            let vm = this;
            let api = `/carts/${row}/updateSpec`;
            let params = {
                specId: specId
            };
            axios.patch(api, params).then( r => {
                vm.getCart();
            })
        },
        sendCartForm() {


            if (this.$refs.form.checkValidity()) {
                swal('訂單傳送中，請稍候...', {
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    button: false
                });
                this.$refs.form.submit();
            } else {
                this.$refs.form.reportValidity();
            }
        }
    }
});

var mySwiper = new Swiper ('.home_swiper', {
    // direction: 'vertical',
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    speed: 1500,
    // autoplay: {
    //     delay: 4000,
    // },
    pagination: {
        el: '.pagination1',
        clickable: true,
    },
});

var mySwiper1 = new Swiper ('.client_swiper', {
    speed: 1500,
    autoplay: {
        delay: 4000,
    },
    slidesPerView:2,
    spaceBetween: 15,
    breakpoints:{
        780:{
            slidesPerView: 3,
            spaceBetween: 30,
        },
        900:{
            slidesPerView: 5,
            spaceBetween: 30,
        },
        1000:{
            slidesPerView: 6,
            spaceBetween: 30,
        }
    },
    pagination: {
        el: '.client_pagination',
        clickable: true,
    },
});

var mySwiper2 = new Swiper ('.shop_swiper', {
    speed: 1500,
    autoplay: {
        delay: 4000,
    },
    pagination: {
        el: '.shop_pagination',
        clickable: true,
    },
});

var mySwiper3 = new Swiper ('.week_swiper', {
    speed: 1500,
    autoplay: {
        delay: 4000,
    },
    pagination: {
        el: '.week_pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.week_next',
        prevEl: '.week_prev',
    }
});

var mySwiper4 = new Swiper ('.cat_swiper', {
    speed: 1500,
    autoplay: {
        delay: 4000,
    },
});

var mySwiper5 = new Swiper ('.more_pd_swiper', {
    speed: 1500,
    autoplay: {
        delay: 4000,
    },
    slidesPerView: 2,
    spaceBetween: 30,
    breakpoints:{
        780:{
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1000:{
            slidesPerView: 5,
            spaceBetween: 30,
        },
        1300:{
            slidesPerView:6,
            spaceBetween: 30,
        }
    },
    pagination: {
        el: '.more_pd_pagination',
        clickable: true,
    },
});

var galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 10,
    slidesPerView: 6,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    centerInsufficientSlides: true,
    slideToClickedSlide: true
});

var galleryTop = new Swiper('.gallery-top', {
    spaceBetween: 10,
    navigation: {
        nextEl: '.gallery_next',
        prevEl: '.gallery_prev',
    },
    thumbs: {
        swiper: galleryThumbs
    },
    on: {
        slideChange: function () {
            let activeIndex = this.activeIndex + 1;
            let activeSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex})`);
            let nextSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex + 1})`);
            let prevSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex - 1})`);
            if (nextSlide && !nextSlide.classList.contains('swiper-slide-visible')) {
                this.thumbs.swiper.slideNext()
            } else if (prevSlide && !prevSlide.classList.contains('swiper-slide-visible')) {
              this.thumbs.swiper.slidePrev()
            }
        }
    }
});
